import React, { useEffect } from 'react'
import { useQuery } from '@apollo/client'

import Layout from '../App/layout'
import ContentLayout from '../../components/utility/layoutContent'
import LayoutContentWrapper from '../../components/utility/layoutWrapper'
import CompanyInfoContainer from './CompanyInfoContainer'
import { COMPANY_NAME_QUERY } from './detail/queries'

const CompanyShowPage = ({ location, match }) => {
    const { id } = match.params

    useEffect(() => { document.title = 'Company Info | OSH CRM' }, [])

    const { data } = useQuery(COMPANY_NAME_QUERY, { variables: { id } })
    const companyName = (data && data.company && data.company.name) ||
        (location.params && location.params.number) || 'บริษัท'

    return (
        <Layout>
            <LayoutContentWrapper breadcrumbs={[
                { path: '/customers', name: 'ลูกค้าและบริษัท' },
                { path: `/companies/${id}`, name: companyName }
            ]}>
                <ContentLayout>
                    <CompanyInfoContainer companyId={id} />
                </ContentLayout>
            </LayoutContentWrapper>
        </Layout>
    )
}

export default CompanyShowPage
